export enum LinkVariants {
    READ_MORE = 'read-more',
    STANDARD_LINK = 'standard-link',
    SMALL_LINK = 'small-link',
    BUTTON_SECONDARY_OUTLINED = 'button-secondary-outlined'
}
